import {ReactNode} from "react";
import {Box, UseToastOptions} from "@chakra-ui/react";

type Scheme = 'success' | 'error';

const BACKGROUND: Record<Scheme, string> = {
  success: 'green.300',
  error: 'red.300',
};

/**
 * Builds the options for a small coloured toast shown in the top-right corner.
 * Use as `toast(toastMessage('Saved', 'success'))`.
 */
export const toastMessage = (message: ReactNode, scheme: Scheme): UseToastOptions => ({
  position: 'top-right',
  render: () => (
    <Box color="white" p={3} bg={BACKGROUND[scheme]}>
      {message}
    </Box>
  ),
});
